export const messages = {
  en: {
    printPayFeeXinShiDai: {
      feeItem: 'Fee Item',
      summary: 'Summary',
      lateFee: 'Late Fee',
      amount: 'Amount',
      to: ' to ',
      none: 'None',
      capitalFormat: 'Capital',
      receiptNum: 'Receipt No.',
      vehicle: 'Vehicle'
    }
  },
  zh: {
    printPayFeeXinShiDai: {
      feeItem: '收费项目',
      summary: '摘要',
      lateFee: '滞纳金',
      amount: '金额',
      to: '至',
      none: '无',
      capitalFormat: '大写',
      receiptNum: '单号',
      vehicle: '车辆'
    }
  }
}

